import React, { useContext } from 'react'
import styled from 'styled-components'
import { UseFormSetValue } from 'react-hook-form'
import { Flex, Label, Radio } from 'pcln-design-system'
import analytics from '@/shared-utils/analytics'
import {
  ANALYTICS_CATEGORY_HOME,
  ANALYTICS_CATEGORY_FLIGHTS
} from '@/constants/analytics'
import BootstrapDataContext from '@/context/BootstrapDataContext'
import {
  FlightFormStateType,
  FlightRecordType,
  FLIGHT_TYPE_INFO,
  FLIGHT_TYPE
} from '../types'

const FlightTypeLabel = styled(Label)`
  cursor: pointer;
`

const gaTrackingTripType = (key: string, flightType: string) => {
  const flightsCategory =
    key === 'flights' ? ANALYTICS_CATEGORY_FLIGHTS : ANALYTICS_CATEGORY_HOME

  analytics.fireEvent({
    category: flightsCategory,
    action: 'Flights Trip Type',
    label: flightType
  })
}

type FlightTypeRadiosProp = {
  flightTypesToDisplay: FLIGHT_TYPE_INFO[]
  setValue: UseFormSetValue<FlightFormStateType>
  flightType: string
  flights: Partial<FlightRecordType>[]
}

export default function FlightTypeRadios({
  flightTypesToDisplay,
  setValue,
  flightType,
  flights
}: FlightTypeRadiosProp) {
  const { key } = useContext(BootstrapDataContext)
  return (
    <>
      {flightTypesToDisplay.map(flightInfo => (
        <Flex mr={3} alignItems="center" key={flightInfo.id}>
          <FlightTypeLabel fontSize={[10, 12]} fontWeight={500} nowrap>
            <Radio
              id={flightInfo.id}
              data-testid={flightInfo.id}
              name="flightType"
              checked={flightType === flightInfo.flightType}
              value={flightInfo.flightType}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setValue('flightType', e.target.value as FLIGHT_TYPE, {
                  shouldDirty: true
                })

                gaTrackingTripType(key, flightInfo.flightType)

                if (Array.isArray(flights) && flights.length > 1) {
                  setValue('flights', [flights[0]], { shouldDirty: true })
                }
              }}
            />
            {flightInfo.typeLabel}
          </FlightTypeLabel>
        </Flex>
      ))}
    </>
  )
}
